import axios from '@/libs/api.request'

export const getTransferList = (params) => {
  return axios.request({
    url: `/warehouse/transferPickupList`,
    method: 'get',
    params
  })
}

export const getPackList = (params) => {
  return axios.request({
    url: `/warehouse/pickupList`,
    method: 'get',
    params
  })
}

